import { type Common } from './common.js';
import { type PatientPCP } from './models/previsit/patient/careTeam.js';
import { type Provider } from './models/provider.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getPatientCareTeam(previsitFormFieldId: string): Promise<(PatientPCP | Provider)[]> {
    const url = this.common.constructPath(`/patient-previsit/patient-care-team`, {
      previsitFormFieldId,
    });
    return await this.common.getJSON(url, undefined, true);
  }
}
